// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jo-z","videoWrapper":"ko-z","twoColumnImage":"lo-z","imageCarouselBtn":"mo-z","carouselNextBtn":"no-z","carouselPrevBtn":"oo-z"};